var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container p-0" },
    [
      _c("h5", [
        _vm._v("\n    " + _vm._s(_vm.$t("Campaign.overview.title")) + "\n  ")
      ]),
      _vm._v(" "),
      _c("campaign-grid", {
        ref: "campaignGrid",
        attrs: {
          activeDate: _vm.getViewedDate,
          listItems: _vm.getDisplayItems,
          removing: _vm.removingEvents,
          defaultStyle: _vm.getDisplayStyle,
          today: _vm.getToday,
          dateRangePickerPresets: _vm.getDateRangePresets,
          allowRangePicker: "",
          useCalendarNavigation: "",
          campaignPreviewItems: "",
          dataSource: "campaign"
        },
        on: {
          setSchedule: _vm.setSchedule,
          changeDate: _vm.setFilteredDate,
          setDisplayStyle: _vm.setDisplayStyle,
          editMpe: _vm.editCampaign,
          removeMpe: _vm.removeCampaign,
          duplicate: _vm.duplicate
        }
      }),
      _vm._v(" "),
      _vm.isEditingMpe
        ? _c("editor-wrapper", {
            attrs: { mpeId: _vm.getEditedMpeId },
            on: { discardChanges: _vm.discardChanges, saveMpe: _vm.saveMpe }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15de9cde", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15de9cde","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/service/campaignManager/CampaignViewer.vue
// module id = null
// module chunks = 